import { AppPorts } from '../elm-ports';
import { NavLocation, RoutingCmdMap } from './Aspect/Navigation/Routing';
import { Browser } from './Aspect/Browser/Browser';
import { Kinded, KnownKeysMatching } from './Aspect/util';

export {
  ElmFrameworkPorts,
  PortOut,
  PortIn,
  handlePortLoopback,
  PortsRecord,
  AllPorts,
  OutPortsKeys,
};

type AllPorts = AppPorts & ElmFrameworkPorts;
type OutPortsKeys = NonNullable<KnownKeysMatching<AllPorts, PortOut<any>>>

interface ElmFrameworkPorts extends PortsRecord {
  lifeCycleEvent: PortIn<LifeCycleEvent>
  copyToClipboard?: PortOut<string>
  openNewTab?: PortOut<string>
  clearSessionStorage?: PortOut
  storeUserId?: PortOut<string>
  storeBrokerSession?: PortOut<string>
  clearBrokerSession: PortOut
  storeWatcherSession?: PortOut<string>
  weAreOnline: PortIn
  detailedError?: PortOut<{ msg: string, extra: any }>
  generalError?: PortOut<string>
  popState: PortIn<{ stateIndex: number, location: NavLocation }>
  routingCommands: PortOut<Kinded<RoutingCmdMap, 'kind'>[]>
  navToLoopback: PortOut<{ url: string, shouldReplace: boolean, shouldSilent: boolean }>
  navToLoopbackSub: PortIn<{ navigationLocation: NavLocation, shouldReplace: boolean, shouldSilent: boolean }>
  windowResize: PortIn<Browser>
  authErrorLoopback: PortOut
  authErrorLoopbackSub: PortIn
  focus: PortOut<string>
  select: PortOut<string>
  setTitleAndDescription?: PortOut<{ title: string, description: string }>
}

type PortIn<T = null> = {
  send: (a: T) => void
}

type PortOut<T = null> = {
  subscribe: (cb: (a: T) => void) => void
}

type LifeCycleEvent = 'Resume' | 'Pause';

type PortsRecord = { [k: string]: PortIn<any> | PortOut<any> | undefined }

const handlePortLoopback = <T>(config: { portOut?: PortOut<T>, portIn: PortIn<T> }): void => {
  config.portOut?.subscribe(val => config.portIn.send(val));
};
